// Header Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../icon_button/icon_button.jsx'

class Header extends Component {
  constructor (props) {
    super(props)

    this.dayNames = DateUtil.getDayNames()
  }

  static get propTypes () {
    return {
      date: PropTypes.number,
      prevMonth: PropTypes.func,
      nextMonth: PropTypes.func,
      onClose: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      date: 0,
      prevMonth: null,
      nextMonth: null,
      onClose: null
    }
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.date !== this.props.date
  }

  render () {
    const { prevMonth, nextMonth, onClose } = this.props
    const date = new Date(this.props.date)

    return (
      <div className='calendar__header'>
        <div className='calendar__month-chooser'>
          <div className='item actioncont'>
            <IconButton
              icon='arrow-left'
              type='primary'
              className='dateaction'
              onClick={prevMonth}
            />
          </div>
          <div className='item datecont'>
            <div className='title'>
              {DateUtil.getDisplayMonth(date)}{' '}
              {`${DateUtil.getDisplayYear(date)}`}
            </div>
          </div>
          <div className='item actioncont'>
            <IconButton
              icon='arrow-right'
              type='primary'
              className='dateaction'
              onClick={nextMonth}
            />
          </div>
          <div className='item actioncont close'>
            <IconButton
              icon='x'
              type='secondary'
              className='dateaction'
              canHover
              onClick={onClose}
            />
          </div>
        </div>
        <table className='calendar__days-names' cellSpacing='0'>
          <tbody>
            <tr>
              <td className='calendar__day-name' key='-1' />
              {this.dayNames.map((i, key) => (
                <td className='calendar__day-name' key={key}>
                  {i}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default Header
